export default {"src":"https://fishbrain.com/_next/static/media/vermont.30bcfddd.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};